import React from 'react';
import cn from 'classnames';

const resultTexts = {
  1: 'Positive',
  2: 'Negative',
};

export const TumorTestResult = ({ data = [] }) => {
  const result = data.find((item) => item.value);

  return (
    <span
      className={cn('fs-12', {
        'color-green': result?.key === 1,
        'color-persian-red': result?.key === 2,
      })}
    >
      {resultTexts[result?.key]}
    </span>
  );
};
